import {useEffect, useRef, useState} from 'react';
import {startQuoteDepositCheckout} from '../../services/quoteDepositCheckoutService';
import {normalizeQuoteContact} from '../../utils/quoteContact';
let stripeScript:Promise<void>|undefined;
export function loadStripeScript(){
 if((window as any).Stripe)return Promise.resolve();
 return stripeScript??=(new Promise<void>((resolve,reject)=>{
  const script=document.createElement('script');script.src='https://js.stripe.com/v3/';script.async=true;
  const fail=()=>{clearTimeout(timer);script.remove();stripeScript=undefined;reject(new Error('Secure payment did not load. Please try again.'))};const timer=setTimeout(fail,20000);script.onload=()=>{clearTimeout(timer);resolve()};script.onerror=fail;document.head.appendChild(script);
 }));
}
/** Signature is already persisted; account details go directly to Stripe. */
export default function InlineDepositPayment({quoteId,client,projectTotal,consultPaid,paymentMode="deposit"}:{paymentMode?:"deposit"|"full";quoteId:string;client:any;projectTotal:number;consultPaid:boolean}){
 const host=useRef<HTMLDivElement>(null),started=useRef(false),checkout=useRef<any>(null),mounted=useRef(true);
 const [error,setError]=useState(''),[ready,setReady]=useState(false);
 const session=useRef<Awaited<ReturnType<typeof startQuoteDepositCheckout>>|null>(null);
 async function open(){
  if(started.current)return;started.current=true;setError('');
  try{
   const stripeReady=loadStripeScript();
   void stripeReady.catch(()=>{});
   const c=normalizeQuoteContact(client);
   const result=session.current??await startQuoteDepositCheckout({quoteRequestId:quoteId,name:c.name,email:c.email,phone:c.phone,projectZip:c.zipCode,projectTotal,consultPaid,paymentMode,embedded:true});
   if(!result.success)throw Error(result.error||'Could not open payment. Please try again.');
   session.current=result;
   if(!mounted.current)return;
   if(result.checkoutUrl){window.location.assign(result.checkoutUrl);return;}
   if(!result.clientSecret||!result.publishableKey)throw Error('Secure payment is temporarily unavailable. Please try again.');
   await stripeReady;if(!mounted.current)return;
   const stripe=(window as any).Stripe(result.publishableKey);
   const form=await stripe.initEmbeddedCheckout({clientSecret:result.clientSecret});
   if(!mounted.current){form.destroy();return;}
   checkout.current=form;form.mount(host.current);setReady(true);
  }catch(e){if(mounted.current)setError(e instanceof Error?e.message:'Could not open payment. Please try again.');started.current=false;}
 }
 useEffect(()=>{mounted.current=true;void open();return()=>{mounted.current=false;checkout.current?.destroy();};},[]);
 return <section className="gc-inline-payment" aria-label="Secure bank payment"><h3>{paymentMode === "full" ? "Pay in full" : "Pay your deposit"}</h3><p className="gc-note">Secure bank payment through Stripe. Your signed agreement and key reminders will be emailed after payment is confirmed.</p>{!ready&&!error&&<p role="status">Opening secure bank payment…</p>}<div ref={host}/>{error&&<><p role="alert">{error} Your signature is saved.</p><button type="button" className="gc-primary" onClick={()=>void open()}>Retry Payment →</button></>}</section>;
}

